import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { documentTypeService } from '../../services/document-type.service'
import { DocumentType } from '../../types'
import { ManagementList } from '../common/ManagementList'
import { DocumentTypeEditDialog } from './DocumentTypeEditDialog'
import { TemplateEditorModal } from './TemplateEditorModal'

export const DocumentTypeList: React.FC = () => {
  const { t } = useTranslation()
  const [templateMappingType, setTemplateMappingType] = useState<DocumentType | null>(null)

  const getDeleteMessage = (object: DocumentType) => {
    return t('confirm_delete_document_type', { name: object.name })
  }

  return (
    <>
      <ManagementList
        service={documentTypeService}
        editDialogComponent={DocumentTypeEditDialog}
        typeName={t('document_type')}
        typeNamePlural={t('document_types')}
        permissionType="document_type"
        getDeleteMessage={getDeleteMessage}
        info={t('document_types_info')}
        infoLink="document_types"
        onExtraAction={(obj) => setTemplateMappingType(obj as DocumentType)}
        extraActionTitle={t('template_mapping') || 'Mapiranje šablona'}
        extraActionIcon="bi bi-file-earmark-ruled"
      />
      {templateMappingType && (
        <TemplateEditorModal
          documentType={templateMappingType}
          show={!!templateMappingType}
          onClose={() => setTemplateMappingType(null)}
          onSuccess={() => documentTypeService.clearCache()}
        />
      )}
    </>
  )
}
